import {
  DatePicker,
  Form,
  Modal,
  Popover,
  Select,
  message,
  Input,
  Pagination,
  Drawer,
} from "antd";

import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { AssetStore } from "../../../assets/AssetsStore";
import styles from "./index.module.scss";
import { Radio } from "antd";
import { useEffect } from "react";
import Spinner from "react-bootstrap/Spinner";
import { ADMIN_USER, USER_DATA } from "../../../constants/const";
import { getFromLocalStorage } from "../../../Helpers/localStorageHelper";
import moment from "moment";
import { createTimeSlots } from "../../../Helpers/DateHelpers";
import { createDropdownValues } from "../../../Helpers/helperFunctions";
import Assets from "../../Layout/Assets";
import AdminAppointmentFilters from "../../RequestFilter";

import {
  FETCH_PAYMENT_TRANSATIONS,
  bookbyorderId,
} from "../../../actions/ClinicAdminAction";
import { INTERBRANCH_MODAL } from "../../../actions/type";
import EmptyTableData from "../../Common/EmptyTableData/EmptyTableData";
import { SearchOutlined } from "@ant-design/icons";
import CustomeModal from "../../CustomeModal/CustomeModal";
import TodaysReportModalContent from "../../RequestModalContent/RequestModalContent";
import { downloadAppointmentRequestreport } from "../../../actions/InterbranchAdminActions";
import { toast } from "react-toastify";
import { Card } from "react-bootstrap";
import { DownOutlined } from "@ant-design/icons";
const RadioGroup = Radio.Group;

function Payments() {
  let [appointments, setAppointments] = useState([]);
  let [acceptModal, setAcceptModal] = useState(false);
  let [reassignModal, setReassignModal] = useState(false);
  let [rejectModal, setRejectModal] = useState(false);
  let [inprogressModal, setInprogressModal] = useState(false);
  let [reAssignData, setReassignData] = useState({});
  let [requestedData, setRequestedData] = useState({});
  let [processdone, setProcessdone] = useState(false);
  let [activePage, setActivePage] = useState(1);
  const [userType, setUserType] = useState();
  let [loader, setLoader] = useState(true);
  let [totalnoofpages, setTotalnoofpages] = useState(0);
  let [isInitial, setinitial] = useState(true);
  let [isModelOpen, setModelOpen] = useState(false);
  let [selectedDate, setSelectedDate] = useState({ from: null, to: null });
  const [selectedStatus, setSelectedStatus] = useState("ALL");
  const userData = JSON.parse(localStorage.getItem("userData"));
  const [filterAppointments, setFilterAppointments] = useState([]);
  const [filteredTotalPages, setFilteredTotalPages] = useState(0);
  const [pendingCount, setPendingCount] = useState(0);
  const [rejectedCount, setRejectedCount] = useState(0);
  const [inprogresscount, setInprogresscount] = useState(0);
  const [callRefresh, setCallRefresh] = useState(false);
  const [fliterby, setFiltertype] = useState("byStatus");
  let [isDownloading, setIsDownloading] = useState(false);
  let [isDownloadingenable, setIsDownloadingenable] = useState(false);
  useEffect(() => {
    checUser();
  }, []);

  const { Option } = Select;

  const dispatch = useDispatch();

  useEffect(() => {
    checUser();
    fetchPaymentTransactions(1); // Fetch initial data for the first page
  }, []);

  const fetchPaymentTransactions = (page) => {
    setLoader(true);
    dispatch(FETCH_PAYMENT_TRANSATIONS(page)).then((res) => {
      setLoader(false);
      setAppointments(res.transactionlist);
      setFilterAppointments(res.transactionlist);
      if (res?.noofpages != undefined) {
        setTotalnoofpages(res?.noofpages);
      }
    });
  };

  useEffect(() => {
    fetchPaymentTransactions(activePage);
  }, [appointments?.appointmentId, selectedStatus]);

  let handlePaginationChange = (e) => {
    console.log("Pagination Change:", e);
    setActivePage(e);
    fetchPaymentTransactions(e);
  };

  const toggleAcceptModal = (flag) => setAcceptModal(flag ? flag : false);
  const toggleReassignModal = (flag) => setReassignModal(flag ? flag : false);
  const toggleRejectModal = (flag) => setRejectModal(flag ? flag : false);
  const toggleInprogressModal = (flag) =>
    setInprogressModal(flag ? flag : false);

  let checUser = async () => {
    getFromLocalStorage(USER_DATA).then((res) => {
      setUserType(JSON.parse(res).userType);
      //    setUserId(JSON.parse(res).userId);
    });
  };

  let handleTableClick = (eachRow) => {
    dispatch(bookbyorderId(eachRow)).then((res) => {
      console.log("res", res);
      if (res?.data?.bookingId) {
        message.success("Booked successfully");
        dispatch(FETCH_PAYMENT_TRANSATIONS(activePage)).then((res) => {
          setAppointments(res.transactionlist);
          setFilterAppointments(res.transactionlist);
          if (res?.noofpages != undefined) {
            //   totalnoofpages=res.data.data.totalNumberOfPages;
            setTotalnoofpages(res?.noofpages);
          }
        });
      }
    });
  };

  const showConfirmation = (eachRow) => {
    Modal.confirm({
      title: "Do you want to Book Now?",
      icon: null,
      centered: true,
      okText: "Yes",
      cancelText: "No",
      okButtonProps: {
        style: {
          backgroundColor: "#0c8de0",
          color: "#fff",
          fontWeight: "500",
          height: "50px",
          width: "110px",
          marginLeft: "10px",
          justifyContent: "center",
          borderRadius: "10px",
          border: "1px solid #0c8de0",
          alignItems: "center",
        },
      },
      cancelButtonProps: {
        style: {
          backgroundColor: "#fff",
          color: "#0c8de0",
          fontWeight: "500",
          height: "50px",
          width: "110px",
          marginLeft: "10px",
          justifyContent: "center",
          borderRadius: "10px",
          border: "1px solid #0c8de0",
          alignItems: "center",
        },
      },

      onOk() {
        handleTableClick(eachRow);
      },
      onCancel() {
        message.info("Did not book");
      },
    });
  };

  function refreshDataWithoutPageChange() {
    //This function is only for refresh data without pagination change. Eg: After accepting the request from modal
    console.log("refreshDataWithoutPageChange");
    localStorage.removeItem("reqid");
    setLoader(true);
    //Passing active pagination from the state as "activePage"
    dispatch(
      FETCH_PAYMENT_TRANSATIONS("90", activePage - 1, selectedStatus, fliterby)
    ).then((res) => {
      setAppointments(res?.data);
      setLoader(false);
    });
  }

  function handleDrawerClose() {
    console.log("handleDrawerClose");
    setModelOpen(false);
    // refreshDataWithoutPageChange();
    dispatch(
      FETCH_PAYMENT_TRANSATIONS("90", activePage - 1, selectedStatus, fliterby)
    ).then((res) => {
      setAppointments(res?.data);
      setPendingCount(res?.pendingCount);
      setRejectedCount(res?.rejectedCount);
      setInprogresscount(res?.InprogressCount);
    });
  }
  console.log("process", processdone);

  return (
    <>
      <div className={styles.requestedAppointmentsWrap}>
        {!loader ? (
          <table className={styles.appointmentsTable}>
            <thead>
              <tr>
                <th>Order Id</th>
                <th>Request Date</th>
                <th>Patient Name</th>
                <th>Transaction Status</th>

                <th>Payment Status</th>
                {/* <th>Notes</th> */}
                <th>Booking Status</th>
              </tr>
            </thead>

            <tbody>
              {appointments?.length > 0 ? (
                appointments.map((eachAppointment, key) => {
                  return (
                    <tr>
                      <td
                        onClick={() => {
                          handleTableClick(eachAppointment.orderId);
                        }}
                      >
                        {eachAppointment?.orderId || "NA"}
                      </td>
                      <td>{eachAppointment?.paymentDatetime || "NA"}</td>
                      <td>
                        {eachAppointment?.requestData?.appointmentDetails
                          ?.appointmentFor === "Loved One" &&
                        eachAppointment?.requestData?.appointmentDetails?.firstName?.trim()
                          ? eachAppointment.requestData.appointmentDetails
                              .firstName
                          : eachAppointment?.PatientName?.replace(
                              "null",
                              ""
                            ).trim() || "NA"}
                      </td>
                      <td style={{ textTransform: "capitalize" }}>
                        {eachAppointment?.transactionStatus || "initiated"}
                      </td>
                      <td style={{ textTransform: "capitalize" }}>
                        {eachAppointment?.transactionStatus === "failed"
                          ? "failed"
                          : eachAppointment?.paymentStatus || "NA"}
                      </td>{" "}
                      {/* <td style={{textTransform:"capitalize"}}>{eachAppointment?.paymentStatus === "Paid" ? "Paid" : "NA" }</td> */}
                      <td>
                        {eachAppointment?.requestId !== undefined
                          ? "Booked"
                          : "Pending"}
                        {eachAppointment?.paymentStatus === "Paid" &&
                        eachAppointment?.requestId === undefined &&
                        eachAppointment?.transactionStatus !== "failed" ? (
                          <button
                            className={styles.inprogress}
                            onClick={() => {
                              showConfirmation(eachAppointment.orderId);
                            }}
                            style={{
                              marginTop: "10px",
                              background: "green",
                              fontSize: "15px",
                            }}
                          >
                            Book Now
                          </button>
                        ) : (
                          ""
                        )}
                      </td>
                      {/* <td>{eachAppointment?.patientname}</td> */}
                      {/* <span>{eachAppointment.patientAge}</span> */}
                      {/* <td>{eachAppointment?.notes !=""?eachAppointment?.notes :"NA"}</td> */}
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan={7}>
                    <EmptyTableData
                      isLoading={loader}
                      haveButton={false}
                      text={
                        isInitial &&
                        "LOOKS LIKE NO REQUEST HAVE BEEN CREATED YET"
                      }
                      caption={""}
                    />
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        ) : (
          <div
            className="loader"
            style={{ width: "100%", textAlign: "center",alignContent:"center" }}
          >
            <Spinner
              style={{
                width: "4rem",
                height: "4rem",
                marginBottom: "15px",
                color: "#01b2e6",
              }}
              animation="border"
              role="status"
            >
              <span className="visually-hidden">Loading...</span>
            </Spinner>
            <div>Please Wait...</div>
          </div>
        )}

        {appointments?.length > 0 && totalnoofpages > 1 && (
          <div
            className="pagination-container paginationWrap"
            text={totalnoofpages}
          >
            <Pagination
              showSizeChanger={false}
              onChange={handlePaginationChange}
              defaultCurrent={activePage}
              total={totalnoofpages * 10}
              hideOnSinglePage={true}
              current={activePage}
            />
          </div>
        )}

        {/* <div className={styles.paginationWrap}>
        <Pagination defaultCurrent={1} total={50} />
      </div> */}
      </div>

      <Drawer
        className={styles.appointmentDetailsDrawer}
        closeIcon={false}
        title={false}
        key={isModelOpen ? "1" : "2"}
        placement="right"
        onClose={handleDrawerClose}
        open={isModelOpen}
      >
        <TodaysReportModalContent
          handleTableRefresh={refreshDataWithoutPageChange}
        />
      </Drawer>
      {/* <CustomeModal
        width={700}
        state={isModelOpen}
        modalName="requestmodal"
        component={}
        isRight
      /> */}
    </>
  );
}

export default Payments;
